// import QAlert from '../components/alert/QAlert.js'
// import uid from '../utils/uid.js'
// import clone from '../utils/clone.js'
import VAlert from 'vuetify/es5/components/VAlert'
import Vue from 'vue'

let notify = {
  create (opts) {
    return this.__vm.add(opts)
  },
  setDefaults (opts) {
    Object.assign(defaults, opts)
  },

  install (args) {
    init.call(this, args)
    // IMPORTARNT self = this
    // si se hacer referencia a this.create(object) peta.
    let self = this
    Vue.notify = function (object) {
      return self.create(object)
    }
    Vue.prototype.$notify = function (object) {
      return self.create(object)
    }

    /*
    args.cfg.notify && this.setDefaults(args.cfg.notify)

    args.$q.notify = this.create.bind(this)
    args.$q.notify.setDefaults = this.setDefaults */
  }
}

Vue.use(notify)

let defaults = {}

function clone (data) {
  const s = JSON.stringify(data)
  if (s) {
    return JSON.parse(s)
  }
}

function s4 () {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)
}
function uid () {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

function init (Vue) {
  const positionList = [
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
    'top',
    'bottom',
    'left',
    'right',
    'center'
  ]
  const node = document.createElement('div')
  document.body.appendChild(node)
  this.__vm = new Vue({
    name: 'QNotifications',
    data: {
      notifs: {
        center: [],
        left: [],
        right: [],
        top: [],
        'top-left': [],
        'top-right': [],
        bottom: [],
        'bottom-left': [],
        'bottom-right': []
      }
    },
    methods: {
      add (config) {
        if (!config) {
          // console.error('Notify: parameter required')
          return false
        }

        const notif = Object.assign(
          {},
          defaults,
          typeof config === 'string' ? { message: config } : clone(config)
        )

        if (notif.position) {
          if (!positionList.includes(notif.position)) {
            // console.error(`Notify: wrong position: ${notif.position}`)
            return false
          }
        } else {
          notif.position = 'top-right'
        }

        notif.__uid = uid()

        if (notif.timeout === void 0) {
          notif.timeout = 6000
        }

        if (!notif.transition) notif.transition = 'scale-transition'
        if (!notif.type) notif.type = 'success'

        const close = () => {
          this.remove(notif)
        }

        if (config.actions) {
          notif.actions = config.actions.map(item => {
            const handler = item.handler
            const action = clone(item)

            action.handler =
              typeof handler === 'function'
                ? () => {
                  handler()
                  !item.noDismiss && close()
                }
                : () => close()

            return action
          })
        }

        if (typeof config.onDismiss === 'function') {
          notif.onDismiss = config.onDismiss
        }

        if (notif.closeBtn) {
          const btn = [
            {
              closeBtn: true,
              label: notif.closeBtn,
              handler: close
            }
          ]
          notif.actions = notif.actions ? notif.actions.concat(btn) : btn
        }

        if (notif.timeout) {
          notif.__timeout = setTimeout(() => {
            close()
          }, notif.timeout + /* show duration */ 1000)
        }
        notif.value = true

        const action = notif.position.indexOf('top') > -1 ? 'unshift' : 'push'
        this.notifs[notif.position][action](notif)

        return close
      },
      remove (notif) {
        if (notif.__timeout) {
          clearTimeout(notif.__timeout)
        }

        const index = this.notifs[notif.position].indexOf(notif)
        if (index !== -1) {
          const ref = this.$refs[`notif_${notif.__uid}`]
          if (ref && ref.$el) {
            const el = ref.$el
            el.style.top = `0px`
            el.style.top = notif.position.includes('bottom') ? '-' : '' + `${el.offsetTop}px`
            el.style.width = getComputedStyle(el).width
          }
          this.notifs[notif.position].splice(index, 1)
          if (typeof notif.onDismiss === 'function') {
            notif.onDismiss()
          }
        }
      }
    },
    render (h) {
      return h(
        'div',
        { staticClass: 'notifications application ' },
        positionList.map(pos => {
          const vert = ['left', 'center', 'right'].includes(pos)
            ? 'center'
            : pos.indexOf('top') > -1
              ? 'top'
              : 'bottom'
          const align =
            pos.indexOf('left') > -1 ? 'start' : pos.indexOf('right') > -1 ? 'end' : 'center'
          const classes = ['left', 'right'].includes(pos)
            ? `align-${pos === 'left' ? 'start' : 'end'} justify-center`
            : pos === 'center'
              ? 'flex-center'
              : `align-${align}`

          return h(
            'transition-group',
            {
              key: pos,
              staticClass: `notification-list notification-list-${vert} fixed layout column ${classes} ma-3`,
              tag: 'div',
              props: {
                name: `notification-${pos}`,
                mode: 'out-in'
              }
            },
            this.notifs[pos].map(notif => {
              return h(
                VAlert,
                {
                  ref: `notif_${notif.__uid}`,
                  key: notif.__uid,
                  staticClass: 'notification subheading ' + (notif.class || ''),
                  props: notif
                },
                [notif.message]
              )
            })
          )
        })
      )
    }
  })
  this.__vm.$mount(node)
}
